import * as React from 'react';
import $ from "jquery";
import { Box, Button, Card, CardContent, CircularProgress, Stack, Typography } from '@mui/material';
import Common from '../../utilities/common';
import { PieChart } from '@mui/x-charts/PieChart';
import Gradient from "javascript-color-gradient";

export interface IComunidadesAutonomasSexoChartState {
    dataMen: any[];
    dataWomen: any[];
}

export default class ComunidadesAutonomasSexoChart extends React.Component<{}, IComunidadesAutonomasSexoChartState> {
    public constructor(props: {}) {
        super(props);

        this.state = {
            dataMen: [],
            dataWomen: []
        }
    }

    componentDidMount(): void {
        this.GetMen();
        this.GetWomen();
    }

    public render(): React.ReactElement<{}> {
        return (
            <Card>
                <CardContent>
                    <Box display={'flex'} justifyContent={'space-between'}>
                        <Typography variant="h5" component="div">
                            Sexo por comunidades autónomas
                        </Typography>
                        <Button variant='text' onClick={() => {
                            window.location.href = '/summary/comunidadesautonomas'
                        }}>
                            Ver todas
                        </Button>
                    </Box>
                    <PieChart
                        series={[
                            {
                                innerRadius: 45,
                                outerRadius: 90,
                                data: this.state.dataMen
                            },
                            {
                                innerRadius: 110,
                                outerRadius: 140,
                                data: this.state.dataWomen
                            }
                        ]}
                        height={429}
                        margin={{
                            left: 100,
                            right: 100,
                            bottom: 0,
                            top: -120
                        }}
                        slotProps={
                            {
                                legend: {
                                    hidden: true
                                }
                            }
                        }
                    />
                    <Stack spacing={2} direction="row" justifyContent={'center'} style={{position: 'relative', top: '-50px'}}>
                        <div style={{width: '20px', height: '20px', backgroundColor: '#89c2d9'}}></div>
                        <Typography variant='caption'>
                            HOMBRES
                        </Typography>
                        <div style={{width: '20px', height: '20px', backgroundColor: '#ffb3c1'}}></div>
                        <Typography variant='caption'>
                            MUJERES
                        </Typography>
                    </Stack>
                </CardContent>
            </Card>
        )
    }

    private GetMen() {
        let url = `${Common.END_POINT}/charts/comunidadesautonomas/total/sex/h`;
        
        $.ajax((
            {
                url: url,
                type: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            const gradientArray = new Gradient()
            .setColorGradient("#89c2d9", "#2a6f97")
            .setMidpoint(response.length)
            .getColors();

            const dataMen: any[] = [];

            for(let i = 0; i < response.length; i++) {
                const dataMenItem: any = {};
                dataMenItem.id = i;
                dataMenItem.value = response[i].total;
                dataMenItem.label = response[i].comunidadAutonoma;
                dataMenItem.color = gradientArray[i];
                dataMen.push(dataMenItem);
            }

            this.setState(
                {
                    dataMen: dataMen
                }
            );
        })
    }

    private GetWomen() {
        let url = `${Common.END_POINT}/charts/comunidadesautonomas/total/sex/m`;
        
        $.ajax((
            {
                url: url,
                type: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            const gradientArray = new Gradient()
            .setColorGradient("#ffb3c1", "#c9184a")
            .setMidpoint(response.length)
            .getColors();

            const dataMen: any[] = [];

            for(let i = 0; i < response.length; i++) {
                const dataMenItem: any = {};
                dataMenItem.id = i;
                dataMenItem.value = response[i].total;
                dataMenItem.label = response[i].comunidadAutonoma;
                dataMenItem.color = gradientArray[i];

                dataMen.push(dataMenItem);
            }

            this.setState(
                {
                    dataWomen: dataMen
                }
            );
        })
    }
}